module.exports = __webpack_public_path__ + "images/help/avatars/luohao-1dff7dad8ea50da0ce4d37f914074fb4.jpg";